import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import {Map, List} from 'immutable';
import {AddHighlightToLibraryDialog} from '@components/call-card/AddHighlightToLibraryDialog';
import LibraryStore from 'stores/library/LibraryStore';
import FileUploadStore from 'stores/files/FileUploadStore';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import CallCardStore from '@store/call-card/CallCardStore';
import AuthStore from 'stores/AuthStore';
import {UserComment} from 'records/UserComment';

interface AddHighlightToLibraryDialogContainerProps {
  callId: FileUploadId;
  open: boolean;
  onClose: () => void;
  selectedHighlight: UserComment;
}

@connectToStores
class AddHighlightToLibraryDialogContainer extends React.PureComponent<
  AddHighlightToLibraryDialogContainerProps &
    ReturnType<typeof AddHighlightToLibraryDialogContainer.getPropsFromStores>
> {
  static getStores() {
    return [LibraryStore, FileUploadStore, CallCardStore, AuthStore];
  }

  static getPropsFromStores(props: AddHighlightToLibraryDialogContainerProps) {
    const {sources} = LibraryStore.getState();
    const callTags = FileUploadStore.getState().callTags;
    const comments = CallCardStore.getState().comments;
    const sessionUser = AuthStore.getState().user;

    return {
      libraries: sources.libraries ?? [],
      tags: callTags.get(props.callId, List()),
      userHighlights: comments
        .get(props.callId, Map())
        .get(sessionUser.id, List())
        .filter(c => c.isRange()),
      sessionUser,
    };
  }

  render() {
    return <AddHighlightToLibraryDialog {...this.props} />;
  }
}

// This removes any props we get from stores so components which use this can ignore them
export default AddHighlightToLibraryDialogContainer as unknown as React.FC<AddHighlightToLibraryDialogContainerProps>;
